import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { Services } from "./components/site/Services";
import { GroundSchoolPromo } from "./components/site/GroundSchoolPromo";
import { Process } from "./components/site/Process";
import { WhyUs } from "./components/site/WhyUs";
import { Showcase } from "./components/site/Showcase";
import { Testimonials } from "./components/site/Testimonials";
import { QuoteForm } from "./components/site/QuoteForm";
import { Footer } from "./components/site/Footer";
import ScrollToHash from "./components/ScrollToHash";
import SEO from "./components/SEO";
import Studios from "./pages/Studios";
import TbirdAg from "./pages/TbirdAg";
import Viewer from "./pages/Viewer";
import Admin from "./pages/Admin";
import GroundSchool from "./pages/GroundSchool";
import EnrollSuccess from "./pages/EnrollSuccess";
import SetPassword from "./pages/SetPassword";
import StudentLogin from "./pages/StudentLogin";
import SchoolLogin from "./pages/SchoolLogin";
import StudentDashboard from "./pages/StudentDashboard";
import LessonViewer from "./pages/portal/LessonViewer";
import QuizEngine from "./pages/portal/QuizEngine";
import ExamEngine from "./pages/portal/ExamEngine";
import AdminAuthoring from "./pages/AdminAuthoring";
import AdminExamPreview from "./pages/AdminExamPreview";
import Verify from "./pages/Verify";

export default function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          {/* Primary routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/studios" element={<Studios />} />
          <Route path="/tbirdag" element={<TbirdAg />} />
          <Route path="/viewer" element={<Viewer />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/authoring" element={<AdminAuthoring />} />
          <Route path="/admin/exam-preview" element={<AdminExamPreview />} />
          <Route path="/groundschool" element={<GroundSchool />} />
          <Route path="/enroll/success" element={<EnrollSuccess />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/login" element={<StudentLogin />} />
          <Route path="/school-login" element={<SchoolLogin />} />
          <Route path="/dashboard" element={<StudentDashboard />} />
          <Route path="/dashboard/exam" element={<ExamEngine />} />
          <Route path="/dashboard/modules/:moduleSlug" element={<LessonViewer />} />
          <Route path="/dashboard/modules/:moduleSlug/quiz" element={<QuizEngine />} />
          <Route path="/verify" element={<Verify />} />

          {/* Legacy WordPress URLs — 301-equivalent redirects to new routes for SEO continuity */}
          <Route path="/geomatics-assets" element={<Navigate to="/" replace />} />
          <Route path="/geomatics-assets/*" element={<Navigate to="/" replace />} />
          <Route path="/film-vfx" element={<Navigate to="/studios" replace />} />
          <Route path="/film-vfx/*" element={<Navigate to="/studios" replace />} />
          <Route path="/agriculture" element={<Navigate to="/tbirdag" replace />} />
          <Route path="/agriculture/*" element={<Navigate to="/tbirdag" replace />} />

          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function HomePage() {
  return (
    <main className="relative bg-black text-white min-h-screen">
      <SEO
        title="Aerial Surveys, LiDAR & 3D Mapping Winnipeg | Thunderbird Geospatial Inc."
        description="Thunderbird Geospatial Inc. serves the Winnipeg area offering aerial surveys, drone mapping, LiDAR, orthomosaics, 3D terrain modelling, thermal imaging, laser scanning, and GIS solutions across Canada."
        canonical="https://tbirdgeo.com/"
      />
      <Navbar />
      <Hero />
      <Services />
      <GroundSchoolPromo />
      <Process />
      <WhyUs />
      <Showcase />
      <Testimonials />
      <QuoteForm />
      <Footer />
    </main>
  );
}
